import type { CityConfig } from "../city-template/types";

export const goffstownConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — NH Dept of State Vital Records", href: "https://sos.nh.gov/vital-records/", description: "Official New Hampshire vital records office in Concord" },
    { label: "Marriage Licenses — Hillsborough County Clerk", href: "https://www.hillsboroughcountynh.org/", description: "Hillsborough County Clerk — marriage license issuance" },
    { label: "Divorce Records — Hillsborough County Superior Court", href: "https://www.courts.nh.gov/", description: "Hillsborough County Superior Court — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of NH SOS for online vital record orders" },
  ],
  city: "Goffstown",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "goffstown",
  route: "/goffstown",
  title: "Emergency Passport Goffstown, NH | Fast Passport Renewal & Expedited Help",
  metaDescription: "Emergency passport and expedited passport services in Goffstown, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Hillsborough County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Goffstown, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Goffstown and southern New Hampshire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Goffstown%20New%20Hampshire%20scenic%20view%20with%20the%20historic%20Main%20Street%2C%20charming%20New%20England%20town%20center%20with%20white%20clapboard%20buildings%20and%20colonial%20architecture%2C%20the%20Piscataquog%20River%20flowing%20through%20the%20town%2C%20warm%20autumn%20foliage%20with%20red%20and%20orange%20maple%20trees%2C%20soft%20golden%20hour%20light%2C%20peaceful%20rural-suburban%20atmosphere%2C%20no%20visible%20text%20or%20people%2C%20photorealistic%20landscape%20with%20warm%20earth%20tones%20and%20green%20rolling%20hills%20in%20background%2C%20clean%20and%20inviting%20small%20town%20scene&width=1800&height=700&seq=goffstown-nh-hero-001&orientation=landscape",
  heroImageAlt: "Goffstown New Hampshire historic Main Street and scenic town center with the Piscataquog River",
  geoPosition: "43.0204;-71.6003",
  geoPlacename: "Goffstown, New Hampshire",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 60–75 minutes from Goffstown via I-93",
  },
  nearbyCitiesZips: [
    { name: "Goffstown", zips: "03045" },
    { name: "Manchester", zips: "03101–03111" },
    { name: "Bedford", zips: "03110" },
    { name: "Weare", zips: "03281" },
    { name: "New Boston", zips: "03070" },
    { name: "Dunbarton", zips: "03046" },
    { name: "Hooksett", zips: "03106" },
    { name: "Auburn", zips: "03032" },
    { name: "Candia", zips: "03034" },
    { name: "Deering", zips: "03244" },
    { name: "Hillsborough", zips: "03244" },
    { name: "Henniker", zips: "03242" },
    { name: "Bradford", zips: "03221" },
    { name: "Warner", zips: "03278" },
    { name: "Suncook", zips: "03275" },
    { name: "Bow", zips: "03304" },
    { name: "Pembroke", zips: "03275" },
    { name: "Concord", zips: "03301–03305" },
    { name: "Loudon", zips: "03307" },
    { name: "Hopkinton", zips: "03229" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent southern New Hampshire departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Manchester", route: "/manchester" },
    { name: "Nashua", route: "/nashua" },
    { name: "Concord", route: "/concord-nh" },
    { name: "Derry", route: "/derry" },
    { name: "Londonderry", route: "/londonderry" },
    { name: "Bedford", route: "/manchester" },
    { name: "Hooksett", route: "/hooksett" },
    { name: "Merrimack", route: "/merrimack" },
  ],
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeNote: "Fast Passport Center serves Goffstown remotely via secure courier. We do not have a walk-in office in Goffstown — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for southern New Hampshire travelers.",
  fpcOfficeDistance: "Serving all of Hillsborough and Merrimack Counties",
  serviceAreaIntro: "From the historic Goffstown Main Street to the Glen Lake area, from the St. Anselm College neighborhood to the rural western hills — Fast Passport Center serves the entire Goffstown community. We regularly help travelers from Manchester, Bedford, Weare, and New Boston get their passports fast.",
  nearbyCitiesIntro: "We serve all Goffstown neighborhoods and nearby southern New Hampshire cities including Manchester, Bedford, Weare, New Boston, Dunbarton, Hooksett, Auburn, Candia, Hillsborough, Henniker, and Concord. If you are in the greater Goffstown area, we have you covered.",
  howItWorksIntro: "Most Goffstown travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency.",
  mistakesIntro: "With Manchester-Boston Regional Airport (MHT) just 15 minutes away, Goffstown travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Goffstown and southern New Hampshire travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Goffstown? Here are the most common ones we hear from southern New Hampshire travelers.",
  statePageRoute: "/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Goffstown international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Goffstown, NH",
      rating: 5,
      text: "My daughter's passport was lost before our family trip to Mexico. Fast Passport Center had a replacement ready in 48 hours. We made our flight with time to spare.",
      service: "Lost Passport",
    },
    {
      name: "Robert M.",
      location: "Bedford, NH",
      rating: 5,
      text: "As a frequent business traveler from the Manchester area, I can't afford passport delays. Fast Passport Center has been my go-to for years. Fast, reliable, and professional.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah K.",
      location: "Weare, NH",
      rating: 5,
      text: "Needed an emergency passport for a work trip to Toronto. Applied Monday morning, had my passport Wednesday afternoon. Absolutely incredible turnaround.",
      service: "Emergency Passport",
    },
    {
      name: "David T.",
      location: "New Boston, NH",
      rating: 5,
      text: "The document review caught an error I would have missed at the post office. That attention to detail saved me weeks of waiting. Worth every penny.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "goffstown-nh-1",
      name: "Goffstown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Main St",
      city: "Goffstown",
      state: "NH",
      zip: "03045",
      phone: "(603) 497-2354",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.3 miles from downtown Goffstown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Goffstown. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "goffstown-nh-2",
      name: "Manchester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Eddy St",
      city: "Manchester",
      state: "NH",
      zip: "03103",
      phone: "(603) 624-0724",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from Goffstown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Large facility with extended hours. Convenient for Goffstown residents. Photo services available. Book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "goffstown-nh-3",
      name: "Bedford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Meetinghouse Rd",
      city: "Bedford",
      state: "NH",
      zip: "03110",
      phone: "(603) 472-4424",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "6 miles from Goffstown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for southern Hillsborough County residents. Limited hours — book appointments early.",
      icon: "ri-mail-line",
    },
    {
      id: "goffstown-nh-4",
      name: "Weare Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "28 N Stark Hwy",
      city: "Weare",
      state: "NH",
      zip: "03281",
      phone: "(603) 529-2195",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "10 miles from Goffstown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for northern Hillsborough County residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "goffstown-nh-5",
      name: "Manchester City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "1 City Hall Plaza",
      city: "Manchester",
      state: "NH",
      zip: "03101",
      phone: "(603) 624-6450",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "8 miles from Goffstown",
      website: "https://www.manchesternh.gov/",
      websiteLabel: "Manchester City Clerk",
      notes: "Major municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "goffstown-nh-6",
      name: "Hooksett Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "25 Riverside Dr",
      city: "Hooksett",
      state: "NH",
      zip: "03106",
      phone: "(603) 485-2354",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "7 miles from Goffstown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Hillsborough County. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Goffstown photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hillsborough County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Goffstown applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Goffstown families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Goffstown travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Manchester or Goffstown." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Goffstown address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Goffstown before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Goffstown for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most southern New Hampshire travelers." },
    { q: "How fast can I renew my passport in Goffstown?", a: "Fast Passport Center offers fast passport renewal in Goffstown in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Goffstown in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Goffstown?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Goffstown residents." },
    { q: "Can I expedite a child passport in Goffstown?", a: "Yes. Fast Passport Center expedites child passports in Goffstown for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Goffstown with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Goffstown?", a: "With Fast Passport Center's emergency courier service, Goffstown travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Goffstown?", a: "Popular options include the Goffstown Post Office (03045), Manchester Post Office (03103), Bedford Post Office (03110), and Manchester City Clerk (03101). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Goffstown?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Manchester or Bedford?", a: "We serve all of southern New Hampshire including Manchester, Bedford, Weare, New Boston, Dunbarton, Hooksett, Auburn, Candia, and Concord. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Goffstown?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Manchester", address: "1100 Hooksett Rd, Manchester, NH 03106", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Manchester", address: "1275 S Willow St, Manchester, NH 03103", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Manchester", address: "1500 S Willow St, Manchester, NH 03103", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
    { name: "UPS Store — Manchester", address: "10 Tara Blvd, Nashua, NH 03062", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Manchester", address: "300 Keller St, Manchester, NH 03103", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Manchester", address: "875 Hanover St, Manchester, NH 03104", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "Postal Annex — Manchester", address: "1000 Eddy St, Manchester, NH 03103", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM", website: "https://www.postalannex.com/" },
    { name: "Costco — Manchester", address: "1000 Eddy St, Manchester, NH 03103", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Manchester", address: "23 Hazard Ave, Manchester, NH 03109", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Passport-ready photo services available. Online appointment booking.", featured: true },
    { name: "DMV — Concord", address: "23 Hazen Dr, Concord, NH 03301", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Appointment required.", featured: false },
    { name: "DMV — Nashua", address: "33 Main St, Nashua, NH 03060", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Milford", address: "4 Meadow Rd, Milford, NH 03055", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for southern New Hampshire residents.", featured: true },
  ],
  airports: [
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "15 miles from Goffstown", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Goffstown travelers. International flights to Canada and Europe. Major domestic hub.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: true },
    { code: "BOS", name: "Boston Logan International Airport", distance: "55 miles from Goffstown", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-93.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
    { code: "CON", name: "Concord Municipal Airport", distance: "18 miles from Goffstown", address: "71 Airport Rd, Concord, NH 03301", note: "Regional airport for general aviation. Charter and private flights available.", flightUrl: "https://www.concordairport.org/", flightLabel: "Concord Airport", featured: false },
  ],
};